import { Layout } from 'antd';
import type React from 'react';

import '../styles/login.css';

const { Header, Content } = Layout;

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <Layout style={{ height: '100vh' }}>
      <Header className="login__header">Delivery Tool Kit</Header>
      <Layout>
        <Content>{children}</Content>
      </Layout>
    </Layout>
  );
};
